module.exports = __webpack_public_path__ + "img/03.a92c4875.png";